<template>
  <tg-layout>
    <template v-if="$user.group > 20" slot="header">
      <tg-search-tool @on-submit="handleSearch">
        <el-input
          :placeholder="$t('component.form.input.placeholder.agent')"
          v-model="searchData.username"
          class="tg-input col-1"
          size="small"
          clearable
        ></el-input>
      </tg-search-tool>
    </template>
    <el-row type="flex" justify="start" style="height: 100%" :gutter="15">
      <el-col
        v-if="$user.group > 20"
        :span="6"
        class="level-distributed--agent"
      >
        <tg-table
          ref="agentTable"
          :columns="agentColumns"
          :proxy="proxy.agent"
          align="center"
          :fit="true"
          :cell-class-name="parseAgentCellClass"
          @cell-click="handleAgentCellClick"
          @on-loaded="handleAgentLoaded"
          :tableHeight="669"
        >
          <template slot="userfullname" slot-scope="scope">
            <tg-user-full-name
              v-bind="scope"
              :class="scope.row.group > 20 ? 'clickable text-primary' : ''"
              @click.native="handleAgentClick(scope)"
            ></tg-user-full-name>
          </template>
        </tg-table>
      </el-col>
      <el-col :span="6" v-if="showLevel">
        <tg-table
          ref="levelTable"
          :columns="levelColumns"
          :proxy="proxy.level"
          align="center"
          :fit="true"
          showSummary
          :summary-method="parseSummary"
          :cell-class-name="parseLevelCellClass"
          @cell-click="handleLevelCellClick"
          @on-loaded="handleLevelLoaded"
        >
        </tg-table>
      </el-col>
      <el-col :span="12" v-if="showMember" class="level-distributed--member">
        <tg-table
          ref="memberTable"
          :columns="memberColumns"
          :proxy="proxy.member"
          align="center"
          :fit="true"
          showPagination
        >
          <template slot="userfullname" slot-scope="scope">
            <tg-user-full-name v-bind="scope"></tg-user-full-name>
          </template>
        </tg-table>
      </el-col>
    </el-row>
  </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgUserFullName from "@/components/slot/TgUserFullName";
import TgSearchTool from "@/components/tool/TgSearchTool";

import { summary } from "@/utils/table";
import str from "@/utils/str";
import apis from "@/apis";
const api = apis.member.distributed;

export default {
  components: {
    TgLayout,
    TgUserFullName,
    TgSearchTool,
  },
  data() {
    return {
      showLevel: false,
      showMember: false,
      groupTag: "",
      upperGroupTag: "",
      agentColumns: [],
      levelColumns: [],
      memberColumns: [],
      searchData: {},
      proxy: api,
      target: {
        username: "",
        group: "",
        groupTag: "",
      },
      agent: null,
      level: 0,
      showUpperAgent: false,
    };
  },
  props: {
    username: String,
  },
  computed: {
    request() {
      return {
        username: this.searchData.username,
      };
    },
    targetGroupComputed() {
      return this.target.group ? this.target.group : this.$user.group;
    },
    targetNameComputed() {
      return this.target.username ? this.target.username : this.$user.username;
    },
  },
  created() {
    let request = this.searchData;

    if (this.username) {
      request.targetName = this.username;
    }

    api.getColumns().then(({ data }) => {
      let agentColumns = data.agentColumns;
      agentColumns[0].renderHeader = this.renderAgentHeader;
      agentColumns[0].children[0].renderHeader = this.renderAgentTag;
      this.agentColumns = agentColumns;

      let levelColumns = data.levelColumns;
      levelColumns[0].renderHeader = this.renderLevelHeader;
      this.levelColumns = levelColumns;

      let memberColumns = data.memberColumns;
      memberColumns[0].renderHeader = this.renderMemberHeader;
      this.memberColumns = memberColumns;

      if (this.$user.group > 20) {
        this.showAgentTable(request);
      } else {
        this.showLevelTable(this.$user);
      }
    });
  },
  methods: {
    renderAgentHeader(h) {
      let col = this.agentColumns[0];
      let lang = "column." + col.langKey;
      let title = this.$t(lang);
      let agent = this.agent;

      if (!agent) {
        agent = {
          username: this.$user.username,
          group: this.$user.group,
        };

        if (this.isSub) {
          agent.username = this.$user.id;
        }
      }

      title =
        title +
        "-" +
        this.$t("column.l" + agent.group) +
        "(" +
        agent.username +
        ")";
      return h("span", title);
    },
    renderAgentTag(h) {
      let col = this.agentColumns[0].children[0];
      let lang = "column." + col.langKey;

      if (!this.groupTag) {
        return h("span", this.$t(lang));
      }

      return h("span", this.$t("column." + this.groupTag));
    },
    renderLevelHeader(h) {
      return h(
        "span",
        {
          class: [],
        },
        this.$t("column.l" + this.targetGroupComputed) +
          "(" +
          this.targetNameComputed +
          ")"
      );
    },
    renderMemberHeader(h) {
      return h("span", "VIP " + this.level + "  " + this.$t("column.l10"));
    },
    parseAgentCellClass({ row, column }) {
      if (column.columnKey == "total") {
        const value = row[column.columnKey];

        if (value != 0) {
          return "clickable text-primary";
        }

        return "";
      }
    },
    handleAgentClick({ row }) {
      if (row.group == 20) {
        return;
      }
      this.closeAllButAgent();

      this.$router.push({
        name: "member.distributed.user",
        params: { username: row.username },
      });
    },
    handleAgentCellClick(row, column) {
      if (column.columnKey == "total") {
        if (row[column.columnKey] == 0) {
          return;
        }
        this.showLevelTable(row);
      }
    },
    addBreadcrumb(row) {
      let title = str.format(
        "{0} ({1})",
        this.$t("column.l" + row.group),
        row.username
      );
      this.$store.commit("breadcrumb/add", {
        id: "member.distributed_" + row.username,
        name: "member.distributed.user",
        query: {
          ...this.$route.query,
        },
        params: {
          username: row.username,
        },
        meta: {
          title: title,
        },
      });
    },
    handleAgentLoaded(response) {
      if(response.retcode == 0){
        this.agent = response.target;

        if (response.data.length > 0) {
          this.showUpperAgent = true;
          this.groupTag = response.groupTag + "_account";
        } else {
          this.showUpperAgent = false;
          this.groupTag = "userfullname";
        }
        if (response.target && response.target.username != this.$user.username) {
          this.addBreadcrumb(response.target);
        }
      }
    },
    showAgentTable(row) {
      this.$refs.agentTable.search(row);
    },
    showLevelTable(row) {
      this.showLevel = true;
      this.$nextTick(() => {
        this.$refs.levelTable.search({ targetName: row.username });

        if (this.$user.group > 20) {
          this.$nextTick(() => {
            this.$refs.agentTable.maxHeight = this.$refs.levelTable.maxHeight;
          });
        }
      });
    },
    showMemberTable(row) {
      this.showMember = true;
      this.level = row.level_name;
      this.$nextTick(() => {
        this.$refs.memberTable.search({
          targetName: this.target.username,
          level: row.level_name,
        });
      });
    },
    parseLevelCellClass({ row, column }) {
      if (column.columnKey == "num") {
        return row[column.columnKey] > 0 ? "clickable text-primary" : "";
      }
      return "";
    },
    handleLevelCellClick(row, column) {
      if (column.columnKey == "num") {
        const value = row[column.columnKey];

        if (value > 0) {
          this.showMemberTable(row);
        }
      }
    },
    handleLevelLoaded(response) {
      this.target = response.target;
    },
    parseSummary({ data }) {
      return summary(
        this.levelColumns,
        data,
        this.$t("component.table.summary"),
        0
      );
    },
    closeAllButAgent() {
      this.showLevel = false;
      this.showMember = false;
    },
    handleSearch() {
      this.closeAllButAgent();
      this.showAgentTable(this.searchData);
    },
    togglePage(hasUser, route) {
      if (hasUser) {
        this.closeAllButAgent();
        this.showAgentTable({ targetName: route.params.username });
      } else {
        this.$store.commit("breadcrumb/clear");
        this.showAgentTable(this.searchData);
      }
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.togglePage(to.params.username, to);
    next();
  },
  watch: {
    username(val) {
      this.togglePage(val, this.$route);
    },
  },
};
</script>
